let descrip, sysEnv, adobeReportSuite, prop3, flowName, prop4, prop48, prop10 ,userId, xmlhttp, Category, SubCategory;
let sc_gid_js = "NA";
export const getOS = () => {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }
    return os;
  };

  export const RemoveHeaderHiddenClass= () => {
    if(!isNullOrUndefined(document.querySelector('.menu.account-menu .no-show'))) {
      document.querySelector('.menu.account-menu .no-show').classList.remove('no-show');
    }
  }
  export const getParentPageTitle = () => {
    let link = window.location.href;
    if(link.indexOf('verizon') < 0) { return ""} 
    let splittedURL = link.slice(0, link.lastIndexOf('/'));
    let title = splittedURL.slice(splittedURL.lastIndexOf('/')+1);
    return title;
  }
  
  export const isNullOrUndefined = (item) => {
    let isNullorUndefined = false;
    if(item === null || item === undefined) {
      isNullorUndefined = true;
    }
    return isNullorUndefined;
  }

  export const updateUserID = () => {
    let userid = "";
    if(!isNullOrUndefined(window.userinfo) && !isNullOrUndefined(window.userinfo.details) && !isNullOrUndefined(window.userinfo.details.userid)) {
      userid = window.userinfo.details.userid;
    }
    document.getElementById('USERID').value= userid;
  }

  export const saveMetrics = (cta) => {
    let metricsData={Event:'Click',Cta:cta};
    callMetrics(metricsData);
  }
  
  export const saveMetricsWithEvent = (eventStr, cta) => {
    let metricsData={Event:eventStr,Cta:cta};
     callMetrics(metricsData);
  }

  export const callMetrics = (metricsData) => {
    fetch('https://'+window.location.hostname+'/support/residential/metrics/update', {
      method: "POST",
      headers: new Headers({
        "content-type": "application/json"
      }),
      body: JSON.stringify(metricsData)
    })
  }

  export const TP_pageLoad = (tabName) =>
  {
    console.log('tabName:'+tabName);
    xmlhttp = GetXmlHttpObject();
    let curURL="";
    if(tabName == 'tv')	
      curURL="/support/consumer/tv";
    else if(tabName == 'phone')	
      curURL="/support/consumer/phone";
    else if(tabName == 'internet')	
      curURL="/support/consumer/internet";
    else if(tabName == 'account')	
      curURL="/support/consumer/account";
    
    if(xmlhttp != null)
    {
      let typeName="tabClick";
      let url = "/support/residential/contact-us/PPSHSendNotificationsServlet?type="+typeName+"&curURL="+curURL;		           
      xmlhttp.open("POST",url,true);
      xmlhttp.send(null);
    }
    
  }

  export const GetXmlHttpObject = () =>
	{
		try
		{
			return new window.ActiveXObject("Msxml2.XMLHTTP"); // It will works in IE browser only
		}
		catch(e)
		{
			try
			{
				return new window.ActiveXObject("Microsoft.XMLHTTP"); // It will works in IE browser only
			}
			catch(e1)
			{
				try
				{
					return new XMLHttpRequest();
				}
				catch(e2)
				{
					return null;
				}
			}
		}
	}
    
  export const getDeviceType = () => {
    let ua = navigator.userAgent.toUpperCase();
    let deviceType;
    if ((ua.indexOf("IPHONE") > -1 || ua.indexOf("IPAD") > -1 || ua
        .indexOf("IPOD") > -1)
        && ua.indexOf("SAFARI") > -1) {
      deviceType = "IPHONESAFARI";
    } else if ((ua.indexOf("IPHONE") > -1 || ua.indexOf("IPAD") > -1 || ua
        .indexOf("IPOD") > -1)
        && ua.indexOf("SAFARI") === -1) {
      deviceType = "IPHONEAPP";
    } else if (ua.indexOf("ANDROID") > -1
        && ua.indexOf("VZAPP-ANDROID") > -1) {
      deviceType = "ANDROIDFIOSAPP";
    } else if (ua.indexOf("ANDROID") > -1) {
      deviceType = "ANDROID";
    } else {
      deviceType = "BROWSER";
    }
    return deviceType;
  }

  export const getAuthStatus = () =>  {
    let authstatus = document.getElementById("loginType");
    return null !== authstatus && undefined !== authstatus ? authstatus.value.toLowerCase() === 'auth'?'auth':'unauth':'unauth';
  }

  export const getDescription = () => {
      /*let url = document.location.href.toLowerCase();
      let realtiveURL = url.substring(url.indexOf('/support/residential/')+'/support/residential/'.length);
      let urlarray=realtiveURL.split('?');
      let category=getPageCategory(urlarray[0]);
      let subCategory=getPageCategory(urlarray[1]);*/		
      let status='';
      if(getAuthStatus()==='auth')
      status='Authenticated';
      else
      status='Unauthenticated';
      descrip="Support Homepage - "+status;
      /*if(subCategory!=" ")
        descrip=descrip+"-"+subCategory;
      else
        descrip=descrip+'-Overview';	*/	
  }

  export const getCookie = (cookie_name) =>  { 
    let results = document.cookie.match ( cookie_name + '=(.*?)(;|$)' );
    console.log("getCookie results"+ results);
    if (results)
    {
    console.log("getCookie results"+ unescape(results[1]));
    return (unescape(results[1]));
    }
    else
    return null;
  }

  export const getCookieValue = name => {
    //debugger;
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  export const unescape = ( str ) => {
    return str.replace( /\\'/g, '\'' );
  }

  export const getTodayDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  }

  export const makeCall = (Step1,Step2,Step3) => {
      TrackUser(Step1,Step2,Step3);
      xmlhttp = GetXmlHttpObject();
      let gid = getCookie("GlobalSessionID")
      let domainNames =window.document.domain; 
      domainNames = domainNames.substring(0,5);  
          
      let gid_dup = "";
      if(gid=="")
      {
        gid_dup=getCookieAPM('GlobalSessionID');
      }
      let timeforPPSH = getTodayDate();
      let PPSHrequesturl = window.location.href;

      if(PPSHrequesturl.indexOf('?')>-1)
      PPSHrequesturl = PPSHrequesturl.substring(0,PPSHrequesturl.indexOf('?'));
      if(xmlhttp != null)
        {
        let url = "/support/residential/contact-us/PPSHSendNotificationsServlet?pagename=contactusnew&step1="+Step1+"&step2="+Step2+"&step3="+Step3+"&timeforPPSH="+timeforPPSH+"&PPSHrequesturl="+PPSHrequesturl+"&gid="+gid+"&gid_dup="+gid_dup;
            xmlhttp.open("POST",url,true);
            xmlhttp.send(null);
        }
      }

      export const getCookieAPM = (cname) => {
		    let name = cname + "=";
		    let ca = document.cookie.split(';');
		    for(let i=0; i < ca.length; i++) {
		        let c = ca[i];
		        while (c.charAt(0)==' ') c = c.substring(1);
		        if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
		    }
		    return "";
		} 

    export const TrackUser = (category, subcategory,contactOptions) => {
      if(category != '')
      Category=category;
      if(subcategory != '')
      SubCategory=subcategory;
      
      let isflow=document.getElementById("loginType").value;
      let Txmlhttp = GetXmlHttpObject();
      if(Txmlhttp != null)
        {
        let url = "/support/residential/contact-us/LogUserInteractionServlet?type=home&isflow="+isflow+"&Category="+Category+"&Subcategory="+SubCategory+"&ContactOptions="+contactOptions;
            Txmlhttp.open("POST",url,true);
            Txmlhttp.send(null);
        }
    }

  
  export const sendCustomEvent = (evt) => {
    if (window.dtm_doplugins) {
        // NORMAL sendCustomEvent CODE STARTS HERE
        if (document.createEvent && document.body.dispatchEvent) {
            let event = document.createEvent('Event');	
            event.initEvent(evt, true, true); //can bubble, and is cancellable
            document.body.dispatchEvent(event);
        } else if (window.CustomEvent && document.body.dispatchEvent) {
            let event = new CustomEvent(evt, {
                bubbles: true,
                cancelable: true
            });
            document.body.dispatchEvent(event);
        }
        // NORMAL sendCustomEvent CODE END HERE
    } else {
        setTimeout(function () { sendCustomEvent(evt); }, 500);
    }
}

export const checkUrlPath = (url) => {
  let modifiedURL = url;
  let windowPath = window.location.pathname;
  let replaceWord = "";
  if(windowPath.indexOf("/residential/") > -1 && url.indexOf('/residential/') === -1 && url.indexOf("/consumer/") > -1) {
    replaceWord = "consumer";
    modifiedURL = url.substring(0, url.indexOf(replaceWord)) + "residential/" +  url.substring(url.indexOf(replaceWord) + 1 + replaceWord.length);
  }
  return modifiedURL;
}

export const IsJsonString = (str) => {
  try {
      JSON.parse(str);
  } catch (e) {
      console.error("Not a valid JSON")
      return false;
  }
  console.log("Valid JSON")
  return true;
}

export const getParentPage = () => {
  var isCheckparent =  localStorage.getItem("ParentPageName");
  var pagename ="";var ischkpage ="";
  if(isCheckparent == null || isCheckparent ==""){   
   
      if(window.oneAppFlag == true)
      {    
        ischkpage ="OneAPPPage";
        localStorage.setItem("ParentPageName",ischkpage);
      }
    
  }else{
    
    var  Prevurl = document.referrer;;
    var  realtiveUrl = Prevurl.substring(Prevurl.indexOf('/support/residential/')+'/support/residential/'.length);
    if(realtiveUrl=='home' || realtiveUrl=='new/home' ){
      if(window.oneAppFlag == true)
      {    
        pagename ="fios support home";
        localStorage.setItem("ParentPageName",pagename);
      }
    }
    if(realtiveUrl=='contact-us/contactuslanding.htm'){
      if(window.oneAppFlag == true)
      {    
        pagename ="fios contactus";
        localStorage.setItem("ParentPageName",pagename);
      }
    }   
   
  }
  return pagename;
}


// WEBPACK FOOTER //
// ./src/components/modules/CommonFunctions.js